export default {
	DISCONNECTED: 'Falha ao buscar as informações.',
	LOST_SESSION: 'Perda de sessão! Você será redirecionado para a tela de login.',
	UNKNOWN: 'Erro desconhecido.',
	FORBIDDEN: 'O usuário não possui acesso à função.',
}
